// Gallery image data configuration
// This allows easy management without hardcoding requires in components

const galleryImages = [
    { id: 1, name: 'chitrakut-1' },
    { id: 2, name: 'chitrakut-2' },
    { id: 3, name: 'chitrakut-3' },
    { id: 4, name: 'chitrakut-4' },
    { id: 5, name: 'chitrakut-5' },
    { id: 6, name: 'chitrakut-6' },
    { id: 7, name: 'chitrakut-7' },
    { id: 8, name: 'chitrakut-8' },
    { id: 9, name: 'chitrakut-9' },
    { id: 10, name: 'chitrakut-10' },
    { id: 11, name: 'chitrakut-11' },
    { id: 12, name: 'chitrakut-12' },
    { id: 13, name: 'chitrakut-13' },
    { id: 14, name: 'chitrakut-14' },
    { id: 15, name: 'chitrakut-15' },
    { id: 16, name: 'chitrakut-16' },
    { id: 17, name: 'chitrakut-17' },
    { id: 18, name: 'chitrakut-18' },
    { id: 19, name: 'chitrakut-19' },
    { id: 20, name: 'chitrakut-20' },
    { id: 21, name: 'chitrakut-21' },
    { id: 22, name: 'chitrakut-22' },
    { id: 23, name: 'chitrakut-23' },
    { id: 24, name: 'chitrakut-24' },
    { id: 25, name: 'chitrakut-25' },
    { id: 26, name: 'chitrakut-26' },
    { id: 27, name: 'chitrakut-27' },
    { id: 29, name: 'chitrakut-29' },
    { id: 30, name: 'chitrakut-30' },
    { id: 31, name: 'chitrakut-31' },
    { id: 32, name: 'chitrakut-32' },
    { id: 33, name: 'chitrakut-33' },
];

export const getGalleryImages = (keywords) => {
    return galleryImages.map(img => ({
        alt: keywords,
        src: require(`../assets/images/gallery/org/${img.name}.jpg`),
        thumbnail: require(`../assets/images/gallery/thumb/${img.name}.jpg`),
        thumbnailWidth: 320,
        thumbnailHeight: 174
    }));
};

export const sliderImages = [
    { id: 1, name: 'slider1', alt: 'Hotel Chitrakut Slider 1' },
    { id: 2, name: 'slider2', alt: 'Hotel Chitrakut Slider 2' },
    { id: 3, name: 'slider3', alt: 'Hotel Chitrakut Slider 3' },
];

export const getSliderImage = (name) => {
    return require(`../assets/images/${name}.jpg`);
};

export default galleryImages;
